/**
 * @generated SignedSource<<487cf8cd444a90f09995abaaf463b463>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IdentityProviderCard_provider$data = {
  readonly displayName: string | null | undefined;
  readonly enableSignout: boolean;
  readonly idpNamespace: string;
  readonly name: string;
  readonly " $fragmentType": "IdentityProviderCard_provider";
};
export type IdentityProviderCard_provider$key = {
  readonly " $data"?: IdentityProviderCard_provider$data;
  readonly " $fragmentSpreads": FragmentRefs<"IdentityProviderCard_provider">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IdentityProviderCard_provider",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableSignout",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "idpNamespace",
      "storageKey": null
    }
  ],
  "type": "SAMLProvider",
  "abstractKey": null
};

(node as any).hash = "66f965a92115ba29e9d4c4efe33379be";

export default node;
